import { useEffect } from "react";

import Options from "components/Options";
import Select from "components/Select";
import useAZZKUYears from "hooks/AZZKU/useAZZKUYears";
import { main_options, secondary_options, range_selects } from "module/AZZKUModule/years"; 

export default function AZZKUResultsYears({ params, onChange }) {

   const { d: years } = useAZZKUYears({
      variable_id: params.variable_id,
      relation_id: params.relation_id,
      profession_ids: params.profession_ids
   });

   useEffect(() => {
      if ( !years ) return;

      let params_years = params.years; 
      let base_year = params.base_year;
      let compare_year = params.compare_year;

      if ( !!params_years?.length ) {
         params_years = params_years.filter( y => !!years.find( year => +year.value === +y ));
      }

      if ( base_year )
         base_year = !!years.find( year => +year.value === +base_year ) ? base_year: undefined; 
      
      if ( compare_year )
         compare_year = !!years.find( year => +year.value === +compare_year ) ? compare_year : undefined;

      onChange({
         base_year,
         compare_year,
         years: params_years
      })
   }, [ years ])
   
   if ( years && !years.length )
      return <div style={{ color: "red" }}> Brak danych dla wybranych zawodów. Wybierz inny zawód z listy filtrów </div>

   return (
      <div>
         <Options
            {...main_options }
            label="Widoczne dane:"
            value={ params[ main_options.name ]}
            style={{ marginBottom: "20px" }}
            onChange={ onChange }
         />

         { params[ main_options.name ] === "raw" && 
            <Options
               {...secondary_options }
               multiple
               extra_classes="mini"
               options={ years || []}
               label=""
               value={ params[ secondary_options.name ]}
               onChange={ onChange }
            />
         }

         { params[ main_options.name ] === "dynamics_change" &&
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "20px" }}>
               { range_selects.map(({ name, ...rest }) => {
                  const other_name = name === "base_year" ? "compare_year" : "base_year";
                  const filtered_years = (years || []).filter( y => String(y.value) !== String(params[ other_name ]));
                  return (
                     <Select
                        key={ name }
                        name={ name }
                        value={ params[ name ]}
                        options={ filtered_years }
                        {...rest }
                        onChange={ onChange }
                     />
                  );
               })}
            </div>
         }
    </div>
   )
}